export * from './array';
export * from './date';
export * from './function';
export * from './keyboard';
export * from './number';
export * from './sort';
export * from './string';
export * from './util';

export const log = (label: string) => (a: any) => {
  console.log(label, a);
  return a;
};
